module.exports = __webpack_public_path__ + "img/contact_a03.41f42135.png";